import Vue from 'vue'
import VueResource from 'vue-resource'
import History from './history.vue'

if ($('#history').length) {
  Vue.use(VueResource)

  new Vue({
    el: '#history',
    components: {
      History
    },
  })
}
